import React from 'react'
import { PaymentPlan } from '@/types/types'
import { formatDollarsAndCents } from '@/helpers/formatPrice'
import { cn } from '@/lib/utils'

interface PlansProps {
  activePlan: number
  handlePlan: (index: number) => void
  plans: PaymentPlan[]
  version?: string
}

export function Plans(props: PlansProps) {
  return props.version && props.version === 'brand' ? (
    <div className="w-screen max-w-[430px] rounded-b-5xl shadow-hero bg-[#ECEEFF] dark:bg-hero pb-6 px-6 -ml-4">
      <div className="flex-col flex gap-2 mt-6 relative z-10">
        {props.plans.map((el, index) => {
          const perDayPrice = formatDollarsAndCents(el.perDayDiscount ?? 0)
          return (
            <div
              key={el.name}
              onClick={() => {
                props.handlePlan(index)
              }}
              className={cn('plan-item', {
                'border-[red] active': index === props.activePlan,
                '': el.mostPopular,
              })}
            >
              {el.mostPopular && (
                <div className=" flex gap-1 w-full text-[14px] p-1 font-medium !text-[#FBFBFB] left-0 items-center justify-center most-popular">
                  MOST POPULAR
                </div>
              )}
              <div className="flex py-2  dark:bg-[#1A1A1D] px-[18px] bg-black rounded-2xl gap-4 w-full items-center justify-between">
                <div className="flex items-center w-full gap-[18px] justify-start">
                  <div className="checkbox min-w-[20px]"></div>
                  <div className="w-full">
                    <div className={'w-full'}>
                      <h3 className="capitalize text-[#A1A1A1] dark:text-[#6E6E70] text-active leading-[27px] font-medium text-[20px]">
                        {el.name}
                      </h3>
                      <div className="flex text-[#A1A1A1] dark:text-[#6E6E70] text-[14px] justify-between mt-1">
                        <p className="leading-[19px]">
                          <span className="text-[#A1A1A1] dark:text-[#6E6E70] mr-[7px] line-through">
                            ${el.originalPrice}
                          </span>{' '}
                          <span>${el.discountedPrice}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex text-[12px] leading-[16px] !flex-col text-[#A1A1A1] dark:text-[#6E6E70] text-center relative">
                  <span className="">${el.perDay}</span>
                  <span className="text-[20px] block -my-0.5 leading-[27px] font-medium text-active">
                    $0.{perDayPrice[1]}
                  </span>
                  <p className="per-day !text-[12px] !leading-[16px] whitespace-nowrap text-active !font-normal">
                    per day
                  </p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  ) : props.version && props.version === 'alternative' ? (
    <div>
      <div className="flex-col flex gap-3 mt-5">
        {props.plans.map((el, index) => {
          const perDayPrice = formatDollarsAndCents(el.perDayDiscount ?? 0)
          return (
            <div
              key={el.name}
              onClick={() => {
                props.handlePlan(index)
              }}
              className={cn('plan-item plan-item-alternative', {
                'border-[red] active': index === props.activePlan,
                '!pt-[54px]': el.mostPopular,
              })}
            >
              {el.mostPopular && (
                <div className="absolute flex gap-2 w-full p-2 font-bold left-0 items-center justify-center text-[14px] tracking-[1px] most-popular top-[-2px]">
                  <img
                    src="/img/fire-icon.png"
                    className="mt-[-2px]"
                    alt="Fire icon"
                    width={16}
                    height={16}
                  />
                  MOST POPULAR
                </div>
              )}
              <div className="flex gap-7 w-full items-center justify-between">
                <div className="flex items-center w-full gap-4 justify-start">
                  <div className="checkbox min-w-[24px]"></div>
                  <div className="w-full">
                    <div className={'w-full'}>
                      <h3 className="uppercase text-white leading-1 font-bold text-[18px]">
                        {el.name}
                      </h3>
                      <div className="flex text-white text-[12px] justify-between">
                        <p>
                          <span className="text-[#555C70] mr-2.5 font-medium line-through">
                            ${el.originalPrice}
                          </span>{' '}
                          <span className="font-medium">${el.discountedPrice}</span>
                        </p>
                        <span className="line-through decoration-[#f83b00] font-medium">
                          ${el.perDay}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="!flex price-wr relative">
                  <span className="dollar-price">$</span>
                  <div className="flex items-center gap-1">
                    <span className="zero-price">0</span>
                    <div>
                      <p className="cent-price">{perDayPrice[1]}</p>
                      <p className="per-day whitespace-nowrap">per day</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  ) : (
    <div>
      <div className="flex-col flex gap-3 mt-9">
        {props.plans.map((el, index) => {
          const perDayPrice = formatDollarsAndCents(el.perDayDiscount ?? 0)
          return (
            <div
              key={el.name}
              onClick={() => {
                props.handlePlan(index)
              }}
              className={cn('plan-item', {
                'border-[red] active': index === props.activePlan,
                '!pt-[40px]': el.mostPopular,
              })}
            >
              {el.mostPopular && (
                <div className="absolute flex gap-1 w-full p-1 font-bold left-0 items-center justify-center most-popular top-[-2px]">
                  <img src="/img/fire-icon.png" alt="Fire icon" width={16} height={16} />
                  MOST POPULAR
                </div>
              )}
              <div className="flex gap-4 w-full items-center justify-between">
                <div className="flex items-center w-full gap-4 justify-start">
                  <div className="checkbox min-w-[24px]"></div>
                  <div className="w-full">
                    <div className={'w-full'}>
                      <h3 className="uppercase text-white leading-1 font-bold text-[18px]">
                        {el.name}
                      </h3>
                      <div className="flex text-white text-[12px] justify-between">
                        <p>
                          <span className="text-[#a9a9a9] mr-2 line-through">
                            ${el.originalPrice}
                          </span>{' '}
                          <span>${el.discountedPrice}</span>
                        </p>
                        <span className="line-through decoration-[#f83b00]">${el.perDay}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex price-wr relative">
                  <span className="dollar-price">$</span>
                  <span className="zero-price">0</span>
                  <p className="cent-price">{perDayPrice[1]}</p>
                  <p className="per-day whitespace-nowrap">per day</p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
